import * as dashBoardActionCreator from "./dashBoardActionCreator";

export function defaultDashBoardListState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const DashboardListReducer = (state, action) => {
    if (
        !state || 
        action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_DASHBOARD_STATE
    ) {
        return { ...state, ...defaultDashBoardListState() };
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST){
        return { ...state, loading:true};
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_DASHBOARD_LIST) {
        return { ...state, response: action.data, loading:false}
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_DASHBOARD_LIST) {
        return { ...state , error:action.data, loading:false}
    }
    return state;
 };

 export function defaultEmpDashBoardListState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const EmpDashboardListReducer = (state, action) => {
    if (
        !state || 
        action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_EMP_DASHBOARD_STATE
    ) {
        return { ...state, ...defaultEmpDashBoardListState() };
    }    

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST){
        return { ...state, loading:true};
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_LIST) {
        return { ...state, response: action.data, loading:false}
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_LIST) {
        return { ...state , error:action.data, loading:false}
    }
    return state;
        
    }


    export function defaultEmpDashBoardMonthlyHoursList() {
        return {
            loading: false,
            response: null,
            error: null
        }
    }
    
    export const EmpDashboardMonthlyHoursReducer = (state, action) => {
        if (
            !state || 
            action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_EMP_DASHBOARD_MONTHLY_HOURS_STATE
        ) {
            return { ...state, ...defaultEmpDashBoardMonthlyHoursList() };
        }    
    
        if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_MONTHLY_HOURS_LIST){
            return { ...state, loading:true};
        }
    
        if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_MONTHLY_HOURS_LIST) {
            return { ...state, response: action.data, loading:false}
        }
    
        if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_MONTHLY_HOURS_LIST) {
            return { ...state , error:action.data, loading:false}
        }
        return state;
            
        }

        export function defaultTimesheetCountState() {
            return {
                loading: false,
                response: null,
                error: null
            }
        }
    
        export const TimesheetCountReducer = (state, action) => {
            if (
                !state ||
                action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_TIMESHEE_COUNT
            ) {
                return { ...state, ...defaultTimesheetCountState() };
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_TIMESHEET_COUNT){
                return { ...state, loading:true};
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_TIMESHEET_COUNT) {
                return { ...state, response: action.data, loading:false}
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_TIMESHEET_COUNT) {
                return { ...state , error:action.data, loading:false}
            }
            return state;
        }


        export function defaultEmpWishesState() {
            return {
                loading: false,
                response: null,
                error: null
            }
        }

        export const EmpWishesReducer = (state, action) => {
            if (
                !state ||
                action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_EMP_WISHES
            ) {
                return { ...state, ...defaultEmpWishesState() };
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_EMP_WISHES){
                return { ...state, loading:true};
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_EMP_WISHES) {
                return { ...state, response: action.data, loading:false}
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_EMP_WISHES) {
                return { ...state , error:action.data, loading:false}
            }
            return state;
        }


        export function defaultWeeklyEfficiencyState() {
            return {
                loading: false,
                response: null,
                error: null
            }
        }

        export const WeeklyEfficiencyReducer = (state, action) => {
            if (
                !state ||
                action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_WEEKLY_EFFECIENCY
            ) {
                return { ...state, ...defaultWeeklyEfficiencyState() };
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_WEEKLY_EFFECIENCY){
                return { ...state, loading:true};
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_WEEKLY_EFFECIENCY) {
                return { ...state, response: action.data, loading:false}
            }
            if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_WEEKLY_EFFECIENCY) {
                return { ...state , error:action.data, loading:false}
            }
            return state;
        }
